<template>
  <div>
    <div id="captcha-element"></div>
    <!-- 隐藏按钮，供原生调用onVerify时模拟点击触发验证码 -->
    <button id="captcha-button" style="display: none;">验证</button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      captchaInstance: null,
    };
  },
  mounted() {
    // 保留原生调用入口，原生APP无需改动
    window.onVerify = this.onVerify;
    this.init();
  },
  methods: {
    init() {
      window.initAliyunCaptcha({
        // 场景ID，请替换为您在验证码2.0控制台新建场景后获取的SceneId
        SceneId: "t89rq668",
        mode: "popup",
        element: "#captcha-element",
        button: "#captcha-button",
        success: (captchaVerifyParam) => {
          window.console && console.log("captchaVerifyParam:", captchaVerifyParam);
          this.onResult(captchaVerifyParam);
        },
        fail: (result) => {
          window.console && console.log("verify fail:", result);
        },
        onError: (errorCode) => {
          window.console && console.log("captcha error:", errorCode);
        },
        getInstance: (instance) => {
          this.captchaInstance = instance;
        },
        slideStyle: {
          width: 360,
          height: 40,
        },
      });
    },
    // 原生APP调用此方法触发验证码
    onVerify() {
      var btn = document.getElementById("captcha-button");
      if (btn) {
        btn.click();
      }
    },
    // 回传验证结果给原生App
    onResult(result) {
      try {
        let params = { result: result };
        window.webkit.messageHandlers.onResult.postMessage(params);
      } catch (e) {
        jsCallback.onResult(result);
      }
    },
  },
};
</script>
